/**
 * Legacy M7 /setup/* → M27 /onboarding/* redirects.
 *
 * Signup and bookmarks used to land on the 5-step setup wizard.
 * The canonical onboarding journey is now the 9-step /onboarding flow.
 */

import { Navigate, useLocation } from "react-router-dom";

const _SETUP_TO_ONBOARDING: Record<string, string> = {
  "": "/onboarding/welcome",
  group: "/onboarding/company",
  entities: "/onboarding/company",
  "org-structure": "/onboarding/jobs-grades",
  employees: "/onboarding/employees",
  "shadow-payroll": "/onboarding/shadow-payroll",
  complete: "/onboarding/go-live",
};

export function SetupRedirect() {
  const { pathname } = useLocation();
  const rest = pathname.replace(/^\/setup\/?/, "");
  const segment = rest.split("/").filter(Boolean)[0] ?? "";
  const target = _SETUP_TO_ONBOARDING[segment] ?? "/onboarding/welcome";
  return <Navigate to={target} replace />;
}
